import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { MessageCircle } from "lucide-react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import StatsSection from "@/components/StatsSection";
import ListingGrid from "@/components/ListingGrid";
import WhyKKTC from "@/components/WhyKKTC";
import AboutSection from "@/components/AboutSection";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";
import { useProperties } from "@/hooks/useProperties";
import { transformProperty } from "@/services/propertyService";

export default function HomePage() {
  const { i18n } = useTranslation();
  const { properties: rawProperties, loading, error } = useProperties();

  // Supabase'den gelen veriyi bileşen formatına dönüştür
  const properties = useMemo(() => {
    if (!rawProperties || rawProperties.length === 0) return null;
    try {
      return rawProperties.map((p) => transformProperty(p, i18n.language));
    } catch (err) {
      console.error('Error transforming properties:', err);
      return null; // null = fallback'e düş
    }
  }, [rawProperties, i18n.language]);

  // Hata durumunda fallback kullan (ListingGrid null alınca kendi statik verisini kullanır)
  if (error) {
    console.error('Failed to load properties from Supabase, falling back to static data:', error);
  }

  return (
    <div className="min-h-screen bg-white" data-testid="home-page">
      <SEOHead />
      <Header />
      <HeroSection />
      <StatsSection />
      <ListingGrid properties={properties} loading={loading && !error} />
      <WhyKKTC />
      <AboutSection />
      <Footer />

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/905338000000"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-xl hover:bg-[#128C7E] transition-colors duration-300 whatsapp-pulse"
        aria-label="WhatsApp"
      >
        <MessageCircle className="w-6 h-6 text-white" />
      </a>
    </div>
  );
}
